// External Imports
import { useEffect, useState } from "react";
import Modal from "../UI/Modal";
import Heading from "../UI/Heading";
import { MdClose } from "react-icons/md";
import DetailPair from "../UI/DetailPair";
import { isoDateToString } from "../../util/format-date";
import LoadingSpinner from "../UI/LoadingSpinner";
import { requestAdminAPI } from "../../api/posh-api";

// Internal Imports

/** ========================================================================
 * * LicenseStatusModal Component
 * This component renders a modal displaying the customer's license status.
 * ========================================================================== */

export default function LicenseStatusModal({
  open,
  setOpen,
  checkrId,
  customerId,
}) {
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState();

  /* =================== FETCH STATUS =================== */
  const fetchStatus = async ({ checkrId, customerId }) => {
    try {
      setLoading(true);
      const record = await requestAdminAPI("check-drivers-license", {
        checkrId,
        customerId,
      });
      console.log("License Status Record:", record);
      if (record.results?.passenger?.validity)
        record.status = record.results?.passenger?.validity;
      else record.status = "PENDING";
      setStatus(record);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (checkrId && open) fetchStatus({ checkrId, customerId });
  }, [open]);

  return (
    <Modal open={open} setOpen={setOpen}>
      <div className="grid gap-8 modal max-w-[600px]">
        <Heading
          title="License Status"
          text="Driver license status is not updated instantly. Once a status check is submitted, it can take up to 10 minutes to receive the results."
          isBackArrow={false}
        >
          <MdClose className="icon" onClick={() => setOpen(false)} />
        </Heading>

        {status ? (
          <div className="info">
            <DetailPair
              label="Date Checked"
              value={isoDateToString(status.created_at)}
              loading={loading}
            />
            <DetailPair label="Source" value="CheckrTrust" loading={loading} />
            <DetailPair
              label="License Number"
              value={status.results?.requested_profile?.driver_license_number}
              loading={loading}
            />
            <DetailPair
              classes={`${
                status.status === "VALID"
                  ? "text-green-600"
                  : status.status === "SUSPENDED"
                  ? "text-red-600"
                  : "text-yellow-600"
              } font-semibold`}
              label="Status"
              value={status.status}
              loading={loading}
            />
          </div>
        ) : (
          <div className="pill">License status not checked.</div>
        )}
        <div className="info">
          {loading ? (
            <LoadingSpinner />
          ) : (
            <button
              onClick={() => fetchStatus({ customerId })}
              className="btn-primary"
            >
              Check Status
            </button>
          )}
        </div>
      </div>
    </Modal>
  );
}
